import Vue from 'vue'
import Router from 'vue-router'
import helloWorld from '@/views/helloWorld'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'helloWorld',
      component: helloWorld
    },
    {
      path: '/werk',
      name: 'werk',
      component: () => import(/* webpackChunkName: "werk" */ './views/werk.vue')
    },
    {
      path: '/werk/avans-hogeschool',
      name: 'werk/avans-hogeschool',
      component: () => import(/* webpackChunkName: "werk/avans-hogeschool" */ './views/werk/avans-hogeschool.vue')
    },
    {
      path: '/werk/first-energy-gum',
      name: 'werk/first-energy-guml',
      component: () => import(/* webpackChunkName: "werk/first-energy-gum" */ './views/werk/first-energy-gum.vue')
    },
    {
      path: '/werk/gowallet',
      name: 'werk/gowallet',
      component: () => import(/* webpackChunkName: "werk/gowallet" */ './views/werk/gowallet.vue')
    },
    {
      path: '/werk/avans-hogeschool',
      name: 'werk/avans-hogeschool',
      component: () => import(/* webpackChunkName: "werk/avans-hogeschool" */ './views/werk/avans-hogeschool.vue')
    },
    {
      path: '/werk/loud-audiovisuals',
      name: 'werk/loud-audiovisuals',
      component: () => import(/* webpackChunkName: "werk/loud-audiovisuals" */ './views/werk/loud-audiovisuals.vue')
    },
    {
      path: '/werk/mobilyze',
      name: 'werk/mobilyze',
      component: () => import(/* webpackChunkName: "werk/mobilyze" */ './views/werk/mobilyze.vue')
    },
    {
      path: '/werk/newschain',
      name: 'werk/newschain',
      component: () => import(/* webpackChunkName: "werk/newschain" */ './views/werk/newschain.vue')
    },
    {
      path: '/werk/team-changing-academy',
      name: 'werk/team-changing-academy',
      component: () => import(/* webpackChunkName: "werk/team-changing-academy" */ './views/werk/team-changing-academy.vue')
    },
    {
      path: '/werk/wageningen-universiteit',
      name: 'werk/wageningen-universiteit',
      component: () => import(/* webpackChunkName: "werk/wageningen-universiteit" */ './views/werk/wageningen-universiteit.vue')
    },
    {
      path: '/werkwijze',
      name: 'werkwijze',
      component: () => import(/* webpackChunkName: "werkwijze" */ './views/werkwijze.vue')
    },
    {
      path: '/cultuur',
      name: 'cultuur',
      meta: { transitionName: 'slide' },

      component: () => import(/* webpackChunkName: "cultuur" */ './views/cultuur.vue')
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import(/* webpackChunkName: "contact" */ './views/contact.vue')
    },
    {
      path: '/illustratie',
      name: 'illustratie',
      component: () => import(/* webpackChunkName: "illustratie" */ './views/illustratie.vue')
    },
    {
      path: '/animatie',
      name: 'animatie',
      component: () => import(/* webpackChunkName: "animatie" */ './views/animatie.vue')
    },
    {
      path: '/branding',
      name: 'branding',
      component: () => import(/* webpackChunkName: "branding" */ './views/branding.vue')
    },
    {
      path: '/netflix',
      name: 'netflix',
      component: () => import(/* webpackChunkName: "netflix" */ './views/netflix.vue')
    },
    {
      path: '/kiosk',
      name: 'kiosk',
      meta: { transitionName: 'slide' },
      component: () => import(/* webpackChunkName: "kiosk" */ './views/kiosk.vue')
    },
    {
      path: '/algemene-voorwaarden',
      name: 'algemene-voorwaarden',
      component: () => import(/* webpackChunkName: "algemene-voorwaarden" */ './views/algemene-voorwaarden.vue')
    },
    {
      path: '/privacy-verklaring',
      name: 'privacy-verklaring',
      component: () => import(/* webpackChunkName: "privacy-verklaring" */ './views/privacy-verklaring.vue')
    },
    {
      path: '/landingspage-branding',
      name: 'landingspage-branding',
      component: () => import(/* webpackChunkName: "landingspage-branding" */ './views/landingspage-branding.vue')
    },
    {
      path: '/gratis-branding-sessie',
      name: 'gratis-branding-sessie',
      component: () => import(/* webpackChunkName: "gratis-branding-sessie" */ './views/gratis-branding-sessie.vue')
    },
    {
      path: '/noIE',
      name: 'noIE',
      component: () => import(/* webpackChunkName: "noIE" */ './views/noIE.vue')
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 500)
    })
  }
})

